var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"global-spinner"},[_c('img',{staticClass:"spinner-img",attrs:{"src":require("./global-spinner.svg")}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }